import CoverGarnish from "common/features/asset/CoverGarnish";
import { FormattedMessage } from "react-intl";
import MiscellaneousCheckmarkCircleFill from "common/icons/MiscellaneousCheckmarkCircleFill.tsx";
import MiscellaneousXCircleFill from "common/icons/MiscellaneousXCircleFill.tsx";
import MiscellaneousTag from "common/icons/MiscellaneousTag.tsx";
import styles from "./StatusGarnish.module.scss";
import { CourseMaterial } from "./coursesLoader";
import { useAllowOptLanguage } from "./useAllowOptLanguage";
import clsx from "clsx";

export default function StatusGarnish({
  materialStatus,
}: Pick<CourseMaterial, "materialStatus">) {
  const allowOptLanguage = useAllowOptLanguage();
  if (
    (materialStatus === "opted_in" || materialStatus === "continuation") &&
    allowOptLanguage
  ) {
    return (
      <CoverGarnish>
        <MiscellaneousCheckmarkCircleFill
          className={clsx(styles.icon, styles.green)}
        />
        <FormattedMessage defaultMessage={"Opted In"} />
      </CoverGarnish>
    );
  } else if (materialStatus === "opted_out" && allowOptLanguage) {
    return (
      <CoverGarnish>
        <MiscellaneousXCircleFill className={clsx(styles.icon, styles.red)} />
        <FormattedMessage defaultMessage={"Opted Out"} />
      </CoverGarnish>
    );
  } else if (materialStatus === "included") {
    return (
      <CoverGarnish>
        <MiscellaneousCheckmarkCircleFill
          className={clsx(styles.icon, styles.green)}
        />
        <FormattedMessage defaultMessage={"Included"} />
      </CoverGarnish>
    );
  } else if (materialStatus === "not_included") {
    return (
      <CoverGarnish>
        <MiscellaneousTag className={clsx(styles.icon, styles.blue)} />
        <FormattedMessage defaultMessage={"Not Included"} />
      </CoverGarnish>
    );
  } else {
    return null;
  }
}
